import {
  PROPERTY_COUNT, CHEQUE_VALUES, COPIES_PER_CHEQUE,
} from './constants';

// The 60 physical cards, built once and then only ever referenced by id.
//
// A card's `id` is also the name of its art file (`public/card-art/<id>.jpg`),
// which is what scripts/extractCardArt.mjs writes. Ids are therefore stable
// forever: renaming one silently breaks an image.

export const CARD_KINDS = {
  PROPERTY: 'property',
  CHEQUE: 'cheque',
};

/** IELLO p2: "30 House cards numbered from 1 to 30." `p7` is the house worth 7. */
export const propertyCards = () => Array.from({ length: PROPERTY_COUNT }, (_, i) => ({
  id: `p${i + 1}`,
  kind: CARD_KINDS.PROPERTY,
  value: i + 1,
}));

/**
 * IELLO p2: two $0 cheques plus two each of $2k-$15k. `c7-0` and `c7-1` are
 * the two $7,000 cheques; identical in play, distinct as physical cards.
 */
export const chequeCards = () => CHEQUE_VALUES.flatMap((value) => (
  Array.from({ length: COPIES_PER_CHEQUE }, (_, copy) => ({
    id: `c${value}-${copy}`,
    kind: CARD_KINDS.CHEQUE,
    value,
  }))
));

const byId = new Map([...propertyCards(), ...chequeCards()].map((card) => [card.id, card]));

export const cardById = (id) => byId.get(id) || null;

export const isProperty = (card) => card?.kind === CARD_KINDS.PROPERTY;
export const isCheque = (card) => card?.kind === CARD_KINDS.CHEQUE;

/**
 * Where this card's face sits on its mod sheet, for the art extractor.
 *
 * Read off the sheets by eye once (2026-08-27) and encoded here rather than
 * assumed: the property sheet is a 10x7 grid whose first 30 cells are the
 * houses in value order, so index = value - 1; the cheque sheet's first 15
 * cells are one face per value in CHEQUE_VALUES order (both copies of a
 * cheque share one face). scripts/extractCardArt.mjs is the only consumer.
 */
export const sheetIndexOf = (card) => {
  if (isProperty(card)) return card.value - 1;
  return CHEQUE_VALUES.indexOf(card.value);
};

/**
 * Both copies of a cheque share one art file (the sheet only has 15 faces),
 * so cheque art is addressed by value, not card id.
 */
export const artFileOf = (card) => (isProperty(card) ? card.id : `c${card.value}`);
